import React from 'react';

import {TwoColumnLayout} from '@/component';

import useTitle from '@/hook/useTitle';
import LossList from "@/page/customer/LossPage/LossList";

export default function LogsPage() {
    useTitle('客户流失 - 客户管理');

    return (
        <TwoColumnLayout>
            <TwoColumnLayout.ContentPanel>
                <LossList />
            </TwoColumnLayout.ContentPanel>
        </TwoColumnLayout>
    );
}
